/** src/lang/ru/messages.js */
const messages = {
  // ==================== HEADER & NAVIGATION ====================
  'dashboard': 'Панель управления',
  'logout': 'Выход',
  'statistics': 'Статистика',
  'reporting': 'Отчетность',
  'download': 'Загрузка',
  'dashboard_logo' : 'Логотип панели управления',
  'tyre_data' : 'Список шин',
  // ==================== TYRE MANAGEMENT ====================
  'new_tyre_entry': 'Новая запись о шине',
  'daily_task': 'Ежедневная задача',
  'tyre_removal': 'Снятие шины',
  'tyre_repair': 'Ремонт шины',
  'tyre_fitment': 'Установка шины',
  'fitment': 'Установка',
  'tyre_history': 'История шин',
  'tyre_daily_task': 'Ежедневная задача по шинам',
  'type': 'Тип',
  'repair_life': 'Ресурс после ремонта',
  'repaired_life': 'Ресурс после ремонта',
  'count': 'Количество',
  //=======================Repair Management ====================
  'add_damage_detail': 'Добавить информацию о повреждении',
  'add_image': 'Добавить изображение',
  'uploaded_images': 'Загруженные изображения',
  'upload_image': 'Загрузить изображение',
  'choose_file': 'Выбрать файл',
  'no_file_chosen': 'Файл не выбран',
  'damage_detail': 'Информация о повреждении',
  'repair_data': 'Данные о ремонте',
  'confirm_delete_image_message': 'Вы уверены, что хотите удалить это изображение? Это действие нельзя отменить.',
  'please_select_cut_number': 'Пожалуйста, выберите номер контрольного разреза.',
  'please_select_remark': 'Пожалуйста, выберите примечание.',
  'please_select_image': 'Пожалуйста, выберите изображение.',
  'please_fill_all_fields': 'Пожалуйста, заполните все обязательные поля!',
  'exceed_of_cuts': 'Превышено допустимое количество разрезов!',
  'damage_added_successfully': 'Повреждение успешно добавлено.',
  'damage_updated_successfully': 'Повреждение успешно обновлено.',
  'damage_deleted_successfully': 'Повреждение успешно удалено.',
  'damage_update_failed': 'Не удалось обновить информацию о повреждении!',
  'invalid_data': 'Недопустимые данные для обновления. Отсутствует идентификатор!',
  'number_of_cut_inserted_completed': 'Ошибка! Введено максимально допустимое количество разрезов!',
  'please_fill_no_of_cut': 'Пожалуйста, заполните поле «Количество разрезов».',
  'repair_delete_failed': 'Не удалось удалить запись о ремонте.',
  // ==================== TYRE DETAILS ====================
  's_no': '№',
  'tyre_number': 'Номер шины',
  'tyre_make': 'Марка шины',
  'tyre_type': 'Тип шины (Рисунок)',
  'tyre_size': 'Размер шины',
  'tyre_status': 'Текущий статус',
  'current_status': 'Текущий статус',
  'otd': 'Заводская глубина протектора (ЗГП)',
  'enter_otd': 'Заводская глубина протектора (ЗГП)',
  'otl': 'Гарантийный пробег (OTL)',
  'rtd_a': 'ОГП А (мм) (%)',
  'rtd_a_wear': 'Износ протектора А (мм)',
  'rtd_b': 'ОГП B (мм) (%)',
  'rtd_b_wear': 'Износ протектора B(мм)',
  'avg_tread_depth': 'Средняя глубина протектора (мм)',
  'avg_tread_wear': 'Средний износ протектора (%)',
  'wear_rate': 'Коэффициент износа (км/мм)',
  'ptl': 'Ожид. пробег (км)',
  'life': 'Пробег',
  'affected_balance_tread': 'Остаток протектора',
  'balance_ptl': 'Остаток ПТЛ',
  'total_ptl': 'Общий ПТЛ',
  'tyre_current_status': 'Текущий статус',
  'of': 'из',
  'requirement_month': 'Требуемое количество месяцев',
  'requirement_days': 'Требуемое количество дней',
  'enter_tyre_number': 'Введите номер шины',
  'enter_fitment_kmr': 'Введите KMR при установке',
  'enter_purchase_order_no': 'Введите номер заказа на поставку',
  'enter_po_number': 'Введите номер заказа на поставку',
  'enter_machine_number': 'Введите номер машины',

  // ==================== VEHICLE/MACHINE ====================
  'machine_make': 'Марка ТС',
  'machine_model': 'Модель ТС',
  'machine_number': 'Номер ТС',
  'vehicle_make': 'Марка ТС',
  'vehicle_model': 'Модель ТС',
  'vehicle_number': 'Номер ТС',
  'truck_make': 'Марка ТС',
  'truck_model': 'Модель ТС',
  'truck_number': 'Номер ТС',
  'position_type': 'Положение (тип)',
  'position': 'Положение',
  'change_position': 'Изменить положение',
  'same_machine': 'То же ТС',
  'other_machine': 'Другое ТС',
  'fitment_in': 'Fitment In',

  // ==================== KILOMETERS & DATES ====================
  'fitment_kmr': 'Километраж на момент установки',
  'kilometers_reading': 'Показания в километрах',
  'kilometer_covered_current': 'Пробег на текущем транспортном средстве, км',
  'kilometer_covered_previous': 'Пробег на предыдущем транспортном средстве, км',
  'first_fitment_date': 'Дата первой установки',
  'purchase_date': 'Дата покупки',
  'from_period': 'Период с',
  'to_period': 'Период по',
  'current_kmr': 'Текущий пробег (км)',
  'current_hmr': 'Текущий пробег (км)',
  'previous_machine_km': 'Предыдущий пробег (км) ТС',
  'current_machine_km': 'Текущий пробег (км) ТС',
  'current_life': 'Текущий пробег',
  'log_book_reading': 'Показания в журнале учета',
  'lbsr': 'Пробег ТС согласно журналу, км',
  'km_cicm': 'Пробег на текущем транспортном средстве, км',
  'km_cipm': 'Пробег на предыдущем транспортном средстве, км',
  'hcicm': 'Пробег на текущем транспортном средстве, км',
  'hcipm': 'Пробег на предыдущем транспортном средстве, км',
  // ==================== REPORTS ====================
  'generate_pdf': 'Создать PDF',
  'export_excel': 'Выгрузить файл',
  'export': 'Экспорт',
  'fitment_report': 'Отчет об установке шин',
  'removal_report': 'Отчет о снятии шин',
  'repair_history': 'Отчет о ремонтах',
  'removal_data': 'Данные о снятии',
  'scrap_tyre_report': 'Отчет по списанным шинам',
  'running_tyre_life': 'Пробег шин',
  'running_tyre_average_life': 'Средний пробег шин — диаграмма',
  'tyre_average_life_statistics': 'Статистика среднего пробега',
  'tyre_requirement_plan': 'ПЛАН ЗАКУПОК ШИН',
  'tyre_stock': 'ШИНЫ НА СКЛАДЕ',
  'tyre_stock_report': 'Наличие шин на складе',
  'stock': 'Запасы',
  'total_stock': 'Итого в наличии шин на складе',
  'requirement_plan': 'План закупок',
  'repaired_date': 'Дата ремонта',
  'repair_status': 'Статус ремонта',
  'tyre_total_life': 'Общий пробег шины',
  'date': 'Дата',
  'service_date': 'Дата обслуживания',
  'cut_no': '№ пореза',
  'cut_number': '№ пореза',
  'patch_no': '№ пластыря',
  'before_repair': 'До ремонта',
  'after_repair': 'После ремонта',
  'please_login': 'Пожалуйста, войдите для скачивания отчетов',
  'download_success': 'Excel успешно скачан!',
  'server_error': 'Ошибка сервера. Пожалуйста, попробуйте снова.',
  'no_response': 'Нет ответа от сервера. Проверьте соединение.',
  'download_failed': 'Не удалось скачать Excel. Попробуйте снова.',
  'repair': 'Ремонт',
  'six_month_forecast': 'ПРОГНОЗ ПОТРЕБНОСТИ В ШИНАХ НА 6 МЕСЯЦЕВ',
  'six_month_forecast_chart': 'Прогноз потребности на 6 месяцев',
  'monthly_requirement_summary': 'Сводка по месяцам',
  'entries': 'Записи',
  'month_year': 'Месяц-Год',
  'required_quantity': 'Требуемое количество',
  'no_data_available': 'Нет данных для выбранных фильтров',
  'total_requirement': 'Общая потребность',
  'avg_per_month_label': 'Среднее в месяц',
  'forecast_info': 'Прогноз показывает потребность в шинах на следующие 6 месяцев начиная с',
  'tyres': 'шин',
  'sizes': 'Размеры',
  'months': 'Месяцы',
  'avg_per_month': 'Среднее',
  'month': 'месяц',
  'tyre_count': 'Количество шин',
  'no_chart_data': 'Нет данных для диаграммы для выбранных фильтров',
  'size_name': 'Размер шины',
  'scrap_count': 'Кол-во списаний',
  'repair_count': 'Ремонты',
  'repair_dates': 'Даты ремонта',
  'repair_date': 'Дата ремонта',
  'hcipm': 'Пробег на предыдущей машине',
  'hcicm': 'Пробег на текущей машине',
  'scrap_reason': 'Причина списания',
  'tyre_size_make': 'Размер и марка шины',
  'entries': 'записи',
  'search_history': 'Поиск по истории',
  'select_tyre_to_search': 'Выберите номер шины для поиска',
  'use_search_box_above_tyre': 'Используйте поле поиска выше для поиска истории шин',
  'please_select_tyre': 'Пожалуйста, выберите номер шины',
  'site_selected': 'Объект выбран',
  'loading_sites': 'Загрузка объектов...',
  'reset_success': 'Фильтры успешно сброшены!',
  'loading_data': 'Загрузка данных...',
  'log_book_reading': 'Показания в журнале учета',
  'success': 'Успешно',
  'tyre_stock_details': 'Детали наличия шин',
  'quantity_with_status': 'Количество по статусу',
  'total_tyre': 'Всего шин',
  'no_status_data': 'Нет данных по статусу',
  'view_all_details': 'Просмотреть все детали',
  'new_tyre_in_stock': 'Новая шина на складе',
  'all_descriptions': 'Все описания',
  'description': 'Описание',
  'pressure' : 'Давление',
  'view': 'Просмотр',
  'details': 'детали',
  'all': 'Все',
  'previous_rtd_a': 'Предыдущий RTD-A',
  'previous_rtd_b': 'Предыдущий RTD-B',
  'previous_kmr': 'Предыдущий пробег',
  'image_details': 'Сведения об изображении',

  // ==================== STATISTICS ====================
  'number_of_projects': 'Количество проектов',
  'total_spare_tyres': 'Всего запасных шин',
  'total_running_tyres': 'Всего работающих шин',
  'number_of_tyres': 'Количество шин',
  'total_new_tyres': 'Всего новых шин',
  'total_scrap': 'Всего списанных',
  'total_removal': 'Всего снятых',
  'total_repair': 'Всего отремонтированных',
  'total_life': 'Пробег итого',
  'avg_life': 'Средний пробег',
  'total_tyres': 'Шин итого',
  'average_life': 'Средний пробег',
  'number_of_regular_tyres': 'Количество КГШ',
  'number_of_cph_tyres': 'Количество шин (руб/км)',
  'average_life_statistics': 'Средний пробег',

  'last_fitment_date': 'Последняя дата установки',
  'last_removal_date': 'Последняя дата снятия',
  'current_life': 'Текущий пробег',
  'view_history_details': 'Просмотреть историю шин',
  // ==================== FILTERS ====================
  'filters': 'Фильтры',
  'requirement_plan_filters': 'Фильтры',
  'stock_filters': 'Фильтры по наличию',
  'average_life_filters': 'Фильтры',
  'select': 'Выбрать',
  'select_site': 'Выбрать объект',
  'select_project': 'Выбрать проект(ы)',
  'select_tyre_make': 'Выбрать производителя шин',

  'select_tyre_size': 'Выбрать размер(ы) шин',
  'select_status': 'Выбрать статус',
  'site': 'Объект',
  'projects': 'Проекты',
  'all_sites': 'Все объекты:',
  'project': 'Проект',

  // ==================== FORMS & BUTTONS ====================
  'add': 'Добавить',
  'edit': 'Редактировать',
  'update': 'Обновить',
  'delete': 'Удалить',
  'save': 'Сохранить',
  'cancel': 'Отмена',
  'reset': 'Сброс',
  'search': 'Поиск',
  'enter': 'Ввод',
  'submit': 'Подтвердить',
  'close': 'Закрыть',
  'previous': 'Предыдущий',
  'next': 'Следующий',
  'view_details': 'Просмотреть подробности',
  'upload': 'Загрузка',
  'in': 'В',
  'on': 'На',
  'at': 'В',
  'showing': 'Показать',
  'rows': 'Количество строк',
  'records': 'Записи',
  'total': 'Всего',
  'page': 'страница',

  // ==================== VIEWS ====================
  'analysis': 'Анализ',
  'graph_view': 'Графический вид',
  'table_view': 'Табличный вид',
  'month': 'Месяц',
  'monthly': 'По месяцам',
  'forecast': 'Прогноз',
  'quantity': 'Количество',

  // ==================== ISSUES ====================
  'raise_issues_list': 'Создать список проблем',
  'raise_new_issue': 'Создать новую проблему',
  'search_by_subject': 'Поиск по теме/сообщению',
  'new_tyre_entry_not_saved': 'Новая запись о шине не сохраняется',
  'no_image': 'Нет изображения',
  'open': 'открыть',
  'message': 'Сообщение',
  'detailed_message': 'Подробное описание проблемы',
  'attachments': 'Вложения',
  'choose_files': 'Выбрать файлы',
  'max_file_size': 'Максимальный размер файла: 2 МБ. Поддерживаемые форматы: .png, .jpg, .pdf, .docx.',
  'remarks': 'Замечания',
  'add_remarks': 'Добавить замечания',
  'status': 'Статус',
  'open_status': 'Открыть',
  'in_progress': 'В процессе',
  'closed': 'Закрыто',
  'submit_issue': 'Подтвердить',
  'action': 'Действие',

  // ==================== MESSAGES ====================
  'record_saved': 'Запись сохранена',
  'record_updated': 'Запись обновлена',
  'record_deleted': 'Запись удалена',
  'error_occurred': 'Произошла ошибка',
  'no_records_found': 'Записи не найдены',
  'no_chart_data': 'Данные диаграммы отсутствуют',
  'no_data_found': 'Данные не найдены',
  'no_data_selected_filters': 'Данные для выбранных фильтров отсутствуют',
  'select_site_project_first': 'Выберите объект и проект, чтобы увидеть доступные размеры',
  'future_projection': 'Прогноз на будущее на основе текущих данных',

  // ==================== LANGUAGE ====================
  'select_language': 'Выберите язык',
  'english': 'Английский',
  'russian': 'Русский',

  // ==================== MONTHS ====================
  'january': 'Январь',
  'february': 'Февраль',
  'march': 'Март',
  'april': 'Апрель',
  'may': 'Май',
  'june': 'Июнь',
  'july': 'Июль',
  'august': 'Август',
  'september': 'Сентябрь',
  'october': 'Октябрь',
  'november': 'Ноябрь',
  'december': 'Декабрь',

  // ==================== MISC ====================
  'po_number': 'Номер закупки',
  'type_make': 'Тип марки',
  'service': 'Обслуживание',
  'data': 'Данные',
  'damage': 'Повреждение',
  'number_of_cut': 'Количество порезов',
  'no_of_cut': 'Количество порезов',
  'number_of_patch': 'Кол-во пластырей',
  'no_of_patch': 'Кол-во пластырей',
  'cut_location': 'Место повреждения',
  'actual_cut_location': 'Место повреждения подробнее',
  'actual_location': 'Место повреждения подробнее',
  'ntc_tc_cut': 'Сквозной/несквозной порез',
  'cut_length': 'Длина пореза',
  'cut_width': 'Ширина пореза',
  'cut_depth': 'Глубина пореза',
  'patch_number': 'Размер пластыря',
  'list': 'Список',
  'image': 'Изображение',
  'remark': 'Примечание',
  'information': 'Информация',
  'hours': 'часов',
  'requirement': 'Потребность',
  'total_requirement': 'Общая потребность',
  'damage_list': 'Список повреждений',
  // ==================== EXCEL HEADERS ====================
  'excel_tyre_number': 'Номер шины',
  'excel_tyre_make': 'Марка шины',
  'excel_tyre_size': 'Размер шины',
  'excel_vehicle_number': 'Номер ТС',
  'excel_machine_number': 'Номер ТС',
  'excel_status': 'Статус',
  'excel_purchase_date': 'Дата покупки',
  'excel_fitment_date': 'Дата установки',
  'excel_removal_date': 'Дата снятия',
  'excel_current_location': 'Текущее местоположение',
  'excel_brand': 'Марка',
  'excel_model': 'Модель',
  'excel_position': 'Положение',
  'excel_life': 'Пробег',
  'excel_total_life': 'Общий пробег',

  // ==================== NAVIGATION TITLES ====================
  'nav_dashboard': 'Панель управления',
  'nav_new_tyre': 'Новая запись о шине',
  'nav_daily_task': 'Ежедневная задача',
  'nav_removal': 'Снятие шины',
  'nav_repair': 'Ремонт шины',
  'nav_fitment': 'Установка шины',
  'nav_reporting': 'Отчетность',
  'nav_history': 'История шин',
  'nav_fitment_report': 'Отчет об установке',
  'nav_removal_report': 'Отчет о снятии',
  'nav_repair_report': 'Отчет о ремонтах',
  'nav_scrap_report': 'Отчет по списанным',
  'nav_running_tyre': 'Пробег шин',
  'nav_avg_life': 'Средний пробег',
  'nav_requirement': 'План закупок',
  'nav_tyre_scrap': 'Списано шины Запись',
  // 'nav_tyre_scrap_report': 'Списанная шина',
  'nav_tyre_scrap_report': 'Ремонт отклонен и шина списана',
  'nav_stock': 'Наличие',
  'nav_tyre_stock_report': 'Склад шин',
  'nav_issues': 'Проблемы',
  'profile': 'Профиль',
  'manual': 'Инструкция',
  'download_manual': 'Скачать инструкцию',
  'nav_new_tyre_report': 'Отчет о новых шинах',
  'cph_inventory': 'Инвентаризация CPH',
  'item_category': 'Категория товара',
  'item_stocks': 'Запасы товаров',
  'item_used': 'Использованные товары',
  'purchase_tyre_entry': 'Запись о покупке шин',
  'purchase_other_items': 'Покупка других товаров',
  'cph_reporting': 'Отчетность CPH',
  'cph_tyre_history': 'История шин CPH',
  'stocks_report': 'Отчет о запасах',
  'purchase_report': 'Отчет о покупках',
  'used_item_report': 'Отчет об использованных товарах',
  'manage_site': 'Управление объектом',
  'site_entry': 'Запись объекта',
  'site_project': 'Проект объекта',
  'manage_user': 'Управление пользователем',
  'user_entry': 'Запись пользователя',
  'manage_customer': 'Управление клиентом',
  'customer_entry': 'Запись клиента',
  'master_entry': 'Основная запись',
  'excel_import_tyre': 'Импорт шин из Excel',
  'excel_import': 'Импорт из Excel',
  'removal_reason_category': 'Категория причины снятия',
  'change_email': 'Изменить Email',
  'change_password': 'Изменить пароль',
  'setting': 'Настройка',
  'download_ids': 'Скачать ID',
  'tyre_status_category': 'Категория статуса шин',
  'tyre_scrap': 'Списание шин',
  'tyre_life_report': 'Отчет о сроке службы шин',
  'type_of_wear': 'Тип износа',
  'used_tyre_type': 'Тип использованных шин',
  'manage_tyre_position': 'Управление положением шин',
  'manage_cut_location': 'Управление местом пореза',
  'manage_accurate_location': 'Управление точным местоположением',

  // Add these at the end of the file, before export default messages;

  // ==================== CUSTOMER DASHBOARD ====================
  'customer_dashboard': 'Панель управления клиента',
  'welcome_to_tyre_management': 'Добро пожаловать в систему управления шинами',
  'your_comprehensive_solution': 'Ваше комплексное решение для управления жизненным циклом шин',
  'home_select_a_report_message': 'Выберите отчет в меню, чтобы просмотреть подробную информацию.',
  'select_report_from_menu': 'Выберите отчет из меню для просмотра подробной информации',
  'select_atleast_one_site_for_search': 'Пожалуйста, выберите хотя бы один объект, чтобы просмотреть отчет.',
  "select_atleast_one_site": "Пожалуйста, выберите хотя бы один объект.",
  "over_all_removal": "Общее количество снятий",
  "over_all_fitment": "Общее количество установок",
  "all_size": "Все размеры",
  "all_make": "Все производители шин",
  "all_project": "Все проекты",
  'select_site_and_click_search': 'Выберите объект из раскрывающегося списка выше и нажмите «Поиск».',
  'loading_report': 'Загрузка отчета...',
  'loading': 'Загрузка...',
  'surya_kiran_group': 'Группа Surya Kiran',
  'pavlik': 'Павлик',
  'pavlik_mines': 'Шахты Павлик',
  'report_type:': 'Тип отчета:',

  // ==================== FILTERS ====================
  'all_projects': 'Все проекты',
  'all_makes': 'Все марки',
  'all_sizes': 'Все размеры',
  'all_status': 'Все статусы',
  'all_sites': 'Все объекты',
  'select_site_first': 'Выберите объект и проект, чтобы увидеть доступные размеры',
  'please_select_site': 'Пожалуйста, выберите хотя бы один объект',
  'select_site_from_dropdown': 'Выберите сайт из выпадающего списка выше и нажмите «Поиск».',
  'click_search_to_view': 'Нажмите Поиск для просмотра данных',
  'select_filters_and_search': 'Выберите фильтры и нажмите кнопку Поиск, чтобы увидеть результаты',
  'no_data_found_try_adjusting': 'Данные не найдены. Попробуйте изменить фильтры',
  'search_filters': 'Фильтры поиска',
  'no_filters': 'Нет фильтров',
  'downloading': 'Загрузка...',
  'download_excel': 'Скачать в Excel',
  'no_filter_found': 'Данные не найдены',
  'not_selected': 'Не выбрано',
  'period': 'Период',
  'to': 'до',

  // ==================== STATISTICS ====================
  'total_tyres': 'Всего шин',
  'total_life_sum': 'Общий пробег',
  'avg_life_km': 'Средний пробег (км)',
  'chart_view': 'Графический вид',
  'tabular_view': 'Табличный вид',
  'records_count': 'Записи',

  // ==================== TYRE STOCK ====================
  'tyre_stock_report': 'Отчет о наличии шин',
  'stock_details': 'Детали наличия',
  'available_stock': 'Доступные запасы',
  'location': 'Местоположение',
  'current_location': 'Текущее местоположение',

  // ==================== SCRAP REPORT ====================
  'scrap_report': 'Отчет о списании',
  'scrap_reason': 'Причина списания',
  'scrap_date': 'Дата списания',
  'scrap_tyre_report': 'Отчет по списанным шинам',
  'tyre_scrap_report': 'Отчет о списании шин',

  // ==================== REQUIREMENT PLAN ====================
  'requirement_plan_report': 'Отчет о плане закупок',
  'monthly_requirement': 'Месячная потребность',
  'yearly_requirement': 'Годовая потребность',
  'projected_requirement': 'Прогнозируемая потребность',

  // ==================== TYRE HISTORY ====================
  'tyre_history_report': 'Отчет об истории шин',
  'life_cycle_history': 'История жизненного цикла',
  'tyre_life_cycle': 'Жизненный цикл шины',
  'installation_history': 'История установки',
  'removal_history': 'История снятия',
  'repair_history': 'История ремонта',

  // ==================== MACHINE HISTORY ====================
  'machine_history_report': 'Отчет по истории ТС',
  'machine_no': 'Номер ТС',
  'tyre_history_by_machine': 'История шин по номеру ТС',

  // ==================== NEW TYRE RUNNING ====================
  'new_tyre_running_report': 'Отчет о новых шинах в работе',
  'new_tyre_used': 'Новые использованные шины',
  'running_tyres': 'Работающие шины',

  // ==================== FITMENT REPORT ====================
  'fitment_report_details': 'Детали отчета об установке',
  'fitment_date': 'Дата установки',
  'fitment_details': 'Детали установки',
  'kmr_at_fitment': 'Пробег при установке',

  // ==================== REMOVAL REPORT ====================
  'removal_report_details': 'Детали отчета о снятии',
  'removal_date': 'Дата снятия',
  'removal_details': 'Детали снятия',
  'kmr_at_removal': 'Пробег при снятии',

  // ==================== TYRE LIFE REPORT ====================
  'tyre_life_report_details': 'Детали отчета о сроке службы',
  'life_details': 'Детали срока службы',
  'total_life_km': 'Общий пробег (км)',

  // ==================== MODAL ====================
  'view_details_modal': 'Просмотреть подробности',
  'close_modal': 'Закрыть',
  'tyre_details': 'Детали шины',
  'history_details': 'Детали истории',

  // ==================== BUTTONS ====================
  'download_report': 'Скачать отчет',
  'generate_report': 'Создать отчет',
  'apply_filters': 'Применить фильтры',
  'clear_filters': 'Очистить фильтры',
  'view_report': 'Просмотреть отчет',
  'export_report': 'Экспортировать отчет',
  'print_report': 'Печать отчета',

  // =====================Search Tab and Inner Tab=============================
  'over_all_fitment': 'Общее количество установок',
  'repaired_fitted': 'Установлены после ремонта',
  'search_by_po_no': 'Поиск по номеру заказа на поставку',
  'search_by_tyre_no': 'Поиск шины по СН',
  'search_by_machine_no': 'Поиск по номеру ТС',
  'search_truck_history': 'Поиск истории ТС',
  'select_truck_number': 'Выборать номер ТС',
  'select_po_no': 'Выберите номер заказа на поставку',
  'select_tyre_number': 'Выберите номер шины',

  'select_machine_no': 'Выбрать номер ТС',
  'loading_truck_numbers': 'Загрузка номеров ТС...',
  'no_truck_numbers_found': 'Номера ТС не найдены',
  'please_select_truck': 'Пожалуйста, выберите номер ТС',
  'please_select_truck_first': 'Пожалуйста, сначала выберите номер ТС',
  'no_data_to_export': 'Нет данных для экспорта. Сначала выполните поиск.',
  'truck': 'ТС',
  'total_records': 'Всего записей',
  'select_truck_to_search': 'Выберите номер ТС для поиска',
  'use_search_box_above': 'Используйте поле поиска выше для поиска истории ТС',
  'view_history_details': 'Просмотреть историю шин',
  'excel': 'Excel',
  'total_life_km': 'Общий пробег (км)',

  //========================================================
  'po_selected': 'Заказ на поставку выбран',
  'tyre_selected': 'Шина выбрана',
  'searching': 'Поиск...',
  'selected': 'Выбрано',

  // ==================== TYRE Positions ====================
  'fr': 'Переднее правое',
  'fl': 'Переднее левое',
  'rli': 'Заднее левое внутреннее',
  'rlo': 'Заднее левое внешнее',
  'rri': 'Заднее правое внутреннее',
  'rro': 'Заднее правое внешнее',
  'rr': 'Заднее правое',
  'rl': 'Заднее левое',
  'front': 'Переднее',
  'rear': 'Заднее',
  // ==================== TYRE CONDITIONS ====================
  'running': 'В работе',
  'scrap': 'Списано',
  'replaced': 'Заменено',
  'removed_for_repair': 'Снято для ремонта',
  'remove_for_repair': 'Снято для ремонта',
  'for_new_spare': 'Новая запасная',
  'spare': 'Запасная',
  'fleet_maintenance': 'Техническое обслуживание',
  'rotation': 'Ротация',
  'tube_puncture': 'Прокол камеры',
  'from_other_mine': 'С другого объекта',
  'repaired': 'Отремонтировано',
  'removed': 'Снято',
  // ==================== Types ====================
  'removal': 'Снятие',
  'fitment': 'Установка',
  'routine_task': 'Регламентная задача',
  'daily_task_data': 'Данные регламентных задач',
  'repair_rejected_scrap': 'Ремонт отклонен и шина списана',
  'scrap_data': 'Данные о списании',
  // ==================== REMOVAL REASONS ====================
  'removal_reason': 'Причина списания',
  'all_reasons': 'Все причины',
  'air_separation': 'Воздушное отслоение',
  'bead_damage': 'Повреждение борта',
  'beyond_repair_center': 'Беговая дорожка, не подлежит ремонту',
  'beyond_repair_shoulder': 'Плечевая зона, не подлежит ремонту',
  'beyond_repair_side_wall': 'Боковвя зона, не подлежит ремонту',
  'burst_blow_out': 'Разрыв/Взрыв',
  'other': 'Другое',
  'scrap_due_to_bead_exposed': 'Списание ввиду обнажения борта',
  'worn_out': 'Износ',
  'for_repair': 'Для ремонта',
  'beyond_repair': 'Не подлежит ремонту',
  'side_change': 'Смена стороны',
  'meter_change': 'Замена счетчика',
  'scrap_due_to_ply_exposed': 'Списание из-за обнажения корда',
  'remove_for_replaced': 'Снятие для замены',
  'remove_for_fleet_maintenance': 'Снятие для технического обслуживания автопарка',
  'repair_rejected': 'Ремонт отклонен',

  //==================Report Title======================================
  'tyre_information': 'ИНФОРМАЦИЯ О ШИНЕ',
  'tyre_performance_history': 'ИСТОРИЯ ЭКСПЛУАТАЦИИ ШИНЫ',
  'summary': 'СВОДКА',
  //================= Repair Cut Translation ===========================
  'side_wall': 'Боковина',
  'tread_area': 'Зона протектора',
  'shoulder': 'Плечевая зона',
  'bead_area': 'Бортовая зона',
  // 'bead_damage' : 'Повреждение бортовой части',
  'air_pocket': 'Воздушный карман',
  'bulging': 'Вздутие',
  'separation': 'Расслоение',
  'burst_impact': 'Разрыв вследствие удара',
  'impact_external_object': 'Удар о внешний предмет',
  'manufacturing_defect': 'Производственный дефект',
  // 'worn_out' : 'Износ',
  'pin_hole': 'Прокол',
  'deep_cut': 'Глубокий порез',
  'through_cut': 'Сквозной порез',
  'non_through_cut': 'Несквозной порез',
  //================= Tyre Condition ===========================
  'tyre_condition_critical': 'Критическое состояние шины?',
  'critical_type': 'Тип критического состояния',
  'is_critical': 'Критическое?',
  'full_worn_out': 'Полный износ',
  'risk_repair': 'Рискованный ремонт',
  'fitment_in': 'Установлено на',
  'select_status_first': 'Сначала выберите статус',
  //=================================================
  'yes': 'Да',
  'no': 'Нет',
  'select_critical_type': 'Выберите тип критического состояния',
  'please_select_critical_type': 'Пожалуйста, выберите тип критического состояния',
  'critical': 'Критический',

  // ==================== СООБЩЕНИЯ О ПРАВАХ ДОСТУПА ====================
  'no_permission_add': 'У вас нет прав на добавление на этой странице.',
  'no_permission_update': 'У вас нет прав на изменение на этой странице.',
  'no_permission_delete': 'У вас нет прав на удаление на этой странице.',
  'no_permission_view': 'У вас нет прав на просмотр этой страницы.',
  'no_item_selected': 'Не выбрана запись для обновления.',
  'no_permission_download': 'У вас нет прав на скачивание на этой странице.',
  'record_not_found': 'Запись не найдена!',
  'please_fill_fields': 'Пожалуйста, заполните следующие поля:',
  'must_be_greater_than_previous': 'должно быть больше предыдущего показания одометра (KMR).',
  'cannot_be_empty': 'не может быть пустым!',
  'save_failed': 'Не удалось сохранить запись!',
  'update_failed': 'Не удалось обновить запись!',
  'delete_failed': 'Не удалось удалить запись!',
  'confirm_delete': 'Вы уверены, что хотите удалить эту запись?',
  'updating': 'Обновление...',
  'saving': 'Сохранение...',
  // ==================== ДОПОЛНИТЕЛЬНЫЕ ПЕРЕВОДЫ ДЛЯ ОТЧЕТА ПО ИСТОРИИ ШИН ====================
  'cph_tyre_history': 'Отчет по истории шин CPH',
  'search_by_site_name': 'Поиск по названию объекта',
  'search_by_date': 'Поиск по дате',
  'search_by_site_project': 'Поиск по проекту объекта',
  'search_by_tyre_make': 'Поиск по производителю шин',
  'business_types': 'Типы бизнеса',
  'regular': 'Обычный',
  'cph': 'CPH',
  'select_site_project': 'Выберите проект объекта',
  'total_repair_life': 'Общий ресурс после ремонта',
  //=====================Statistics===============================//
  'statistics': 'Статистика',
  'total_running': 'Всего в эксплуатации',
  'total_removed': 'Всего снято',
  'total_remove_for_repair': 'Всего снято для ремонта',
  'total_repaired': 'Всего отремонтировано',
  'total_spare': 'Всего запасных шин',
  'total_critical_tyres': 'Всего критических шин',
  'total_scrap': 'Всего списано',
  'new_tyre_in_stock' : 'Новые шины на складе',
  'critical_tyre_report': 'Отчет по критическим шинам',

};

export default messages;